/*
 * Разбор того, что оператор вставил в пикер кампаний вместо поиска: голый id
 * кампании Meta или ссылка Ads Manager. Возвращает id кампаний — без повторов,
 * в порядке появления; не узнано — пустой список.
 */
const ID_RE = /^\d{1,30}$/;
/**
 * Сколько цифр должно быть в запросе, чтобы предложить его как id кампании,
 * которой нет в нашей базе. У Meta id кампаний длинные (13–18 цифр); короче —
 * это ещё набираемый префикс, а не id.
 */
export const CAMPAIGN_RAW_ID_MIN_DIGITS = 10;
/** Параметры ссылки Ads Manager, в которых лежат id кампаний (через запятую). */
const URL_ID_PARAMS = [
    'selected_campaign_ids',
    'campaign_ids',
    'selected_campaign_id',
    'campaign_id',
];
const isFacebookHost = (host) => /(^|\.)facebook\.com$/i.test(host);
function toUrl(raw) {
    if (/\s/.test(raw))
        return null;
    const withScheme = /^https?:\/\//i.test(raw)
        ? raw
        : /^[\w.-]+\.\w+\//.test(raw)
            ? `https://${raw}`
            : null;
    if (withScheme === null)
        return null;
    try {
        return new URL(withScheme);
    }
    catch {
        return null;
    }
}
/**
 * id, набранный или скопированный с пробелами («1202 1000 0000»): строка из
 * цифр и пробелов → только цифры. Прочее — как есть.
 */
export function normalizeCampaignIdInput(raw) {
    return /^[\d\s]+$/.test(raw) && /\d/.test(raw) ? raw.replace(/\s+/g, '') : raw;
}
/** Это ссылка (а не текст для поиска по названию). */
export function looksLikeUrl(raw) {
    return toUrl(raw.trim()) !== null;
}
/**
 * id кампаний из ввода:
 * - только цифры → этот id;
 * - ссылка Ads Manager (`*.facebook.com`) → `selected_campaign_ids` /
 *   `campaign_ids` / `campaign_id` или фильтр `filter_set=…CAMPAIGN_ID…`;
 * - иначе — `[]` (это поиск по названию).
 * `act=` (кабинет) id кампании не считается.
 */
export function parseCampaignInput(raw) {
    const t = normalizeCampaignIdInput(raw).trim();
    if (t === '')
        return [];
    if (ID_RE.test(t))
        return [t];
    const url = toUrl(t);
    if (url === null || !isFacebookHost(url.hostname))
        return [];
    const out = new Set();
    for (const key of URL_ID_PARAMS) {
        for (const v of url.searchParams.getAll(key)) {
            for (const part of v.split(',')) {
                const id = part.trim();
                if (ID_RE.test(id))
                    out.add(id);
            }
        }
    }
    if (out.size === 0) {
        // фильтр списка: filter_set=SEARCH_BY_CAMPAIGN_ID-STRING_SET\x1EANY\x1E["1202…"]
        const filter = url.searchParams.get('filter_set') ?? '';
        const at = filter.toUpperCase().indexOf('CAMPAIGN_ID');
        if (at >= 0) {
            for (const m of filter.slice(at).matchAll(/\d{6,30}/g))
                out.add(m[0]);
        }
    }
    return [...out];
}
/** Запрос — уже целый id кампании (а не префикс): его можно взять как есть. */
export function isRawCampaignId(raw) {
    const t = raw.trim();
    return ID_RE.test(t) && t.length >= CAMPAIGN_RAW_ID_MIN_DIGITS;
}
//# sourceMappingURL=campaign-input.js.map